import { useCallback, useEffect, useMemo, useState } from "react";

import { getSearchList } from "@/api/endpoints/searches";
import AlertContext from "@/contexts/AlertContext";
import { groupSearches } from "@/lib/alert";

/**
 * AlertProvider
 * Keeps track of a users searches, or alerts globally
 * This is really just needed in the menu, and could be locally
 * fetched for other places needed. Right now we're not using
 * that much info from the search model unless editing it,
 * so we can get away ( making the app much faster) with just
 * using the list-view and fetching the detail view on the
 * settings pages
 */
const AlertProvider = ({ children }) => {
  const [alerts, setAlerts] = useState(null);

  const groupedAlerts = useMemo(() => groupSearches(alerts), [alerts]);

  // If this needs more functionality than a pure patch, migrate to useReducer
  const patchAlert = useCallback((uuid, patch) => {
    setAlerts((alerts) =>
      alerts.map((alert) =>
        alert.uuid === uuid ? { ...alert, ...patch } : alert
      )
    );
  }, []);

  useEffect(() => {
    // after moving the subscriptions inside of the settings-page we can refer to using the light search endpoint
    getSearchList({ light: true })
      .then(({ data = [] }) => {
        setAlerts(data);
      })
      // perhaps handle this if it's not a 401 ? ignore for now.
      .catch(() => {
        // Intentionally left empty
      });
  }, []);

  const refresh = useCallback(() => {
    return getSearchList({ light: true }).then(({ data = [] }) => {
      setAlerts(data);
    });
  }, []);

  return (
    <AlertContext.Provider
      value={{
        alerts,
        patchAlert,
        groupedAlerts,
        refresh,
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};

export default AlertProvider;
